import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpRequest, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {  PickUpCenter, SubstPolicy, PlusiCard, Carrusel, UnitMeasure } from '../_models';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { tap, map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class UtilsService {

  public pickupCenters: PickUpCenter[] = [];
  //20250602 axa inici
  public pickupCentersAxA: PickUpCenter[] = [];
  //20250602 axa final
    public units : Map<string, UnitMeasure[]> = new Map();
   
    constructor(
            private http: HttpClient,
            private translate: TranslateService,
            private dom : DomSanitizer,
            private router : Router
        )
    {
            // console.log('init utils');
            this.getPickUpCenters().subscribe(result => {
                this.pickupCenters = result;
            });
            //20250602 axa inici
            this.getPickUpCentersAxA().subscribe(result => {
              this.pickupCentersAxA = result;
            });
            //20250602 axa final
            this.getUnits('ca').subscribe(result => {
                this.units.set('ca', result);
                this.getUnits('es').subscribe(result => {
                    this.units.set('es', result);
                });
            });
    }


    ///////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////// INTERNS/////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////
    
    getClientIp(): Observable<any>  {
        return this.http.get<any>('https://api.ipify.org/?format=json');
    }

    getDays(): any[] {
        // console.log('getDays');
        let i : number = 0;
        const days = [];

        for (i = 1; i <= 31; i++){
          days.push(i)
        }
        return days;
    }

    
    getMonths() : any[] {
        // console.log('getMonths');
        let i : number = 0;
        let month = [];

        for (i = 1; i <= 12; i ++ ){
            month.push({id: i, name: this.translate.instant (`MONTH_${i}`) });
        }
        return month;       
    }

    getYears(): any[] {
        // console.log('getYears');
        let i = 0;
        const years = [];
       
        let date = new  Date();
        for (i = 0; i <= 100; i++){
          years.push( date.getFullYear() - 18 - i );
        }
        return years;
    }

    /**
     * Returns a random number between min (inclusive) and max (exclusive)
     */
    public getRandomArbitrary(min : number, max : number)  {
        return Math.random() * (max - min) + min;
    }
    
    /**
     * Returns a random integer between min (inclusive) and max (inclusive).
     * The value is no lower than min (or the next integer greater than min
     * if min isn't an integer) and no greater than max (or the next integer
     * lower than max if max isn't an integer).
     * Using Math.round() will give you a non-uniform distribution!
     */
    public getRandomInt(min : number, max : number) : number{
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

        /*

    this.http.request(SearchEndpoint, new RequestOptions({
    method: RequestMethod.Get,
    body: q.BuildPayload()
})).subscribe(...);


    */

   private getEventMessage(event: HttpEvent<any>) {
        switch (event.type) {
            case HttpEventType.Response:
            return `end`;

        }
    }

    toParams(obj): HttpParams{
        let params: HttpParams = new HttpParams();
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                params.set(key, obj[key]);
        }
    return params;
    }



    ///////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////// SUPSA //////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////
    getProvince(zipCode : string) : Observable<string> {
        return this.http.get<string>(`${environment.API_ENDPOINT}utils/${zipCode}/provincia`);
    }

    getPickUpCenter(zipCode : string) : Observable<string> {
        return this.http.get<string>(`${environment.API_ENDPOINT}utils/${zipCode}/centre`);
    }

    getPickUpCenters() : Observable<PickUpCenter[]> {
        return this.http.get<PickUpCenter[]>(`${environment.API_ENDPOINT}utils/centres`).pipe(
            map( result => {
                result.forEach( center =>{
                    center.mapURL =  this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${center.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
                });
                return result;
            })
        );
    }

  //20250602 axa inici
  getPickUpCentersAxA(): Observable<PickUpCenter[]> {
    return this.http.get<PickUpCenter[]>(`${environment.API_ENDPOINT}utils/centresAxA`).pipe(
      map(result => {
        result.forEach(center => {
          center.mapURL = this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${center.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
        });
        return result;
      })
    );
  }
//20250602 axa final

    getSubstPolicies (langCode : string) : Observable<SubstPolicy[]> {
        return this.http.get<SubstPolicy[]>(`${environment.API_ENDPOINT}utils/polsub/${langCode}`); 
    }

    validatePlusiCard (phone : string, date: string) : Observable<string> {
        return this.http.get<string>(`${environment.API_ENDPOINT}fidelity/card?phone_plusi_card=${phone}&birth_plusi_card=${date}`);
    }
    
    /* OBSOLETE ?
    getPlusiCard (phone : string, date: string) : Observable<PlusiCard> {
        return this.http.get<PlusiCard>(`${environment.API_ENDPOINT}fidelity/punts?phone_plusi_card=${phone}&birth_plusi_card=${date}`);
    }
    */

   getCarrusel(id_carrusel : number, langCode : string) : Observable<Carrusel> {
        return this.http.get<Carrusel>(`${environment.API_ENDPOINT}carrusel/${id_carrusel}/${langCode}`);
    }

    getUnits(langCode : string) : Observable<UnitMeasure[]> {
        /*
        if (this.units.has(langCode)){           
            return of(this.units.get(langCode));
        }
        */
        return this.http.get<UnitMeasure[]>(`${environment.API_ENDPOINT}utils/units/${langCode}`).pipe(
            tap( result => {
                this.units.set(langCode , result);
            })
        );
    }


   
    getPickUpCenterName(code : string) : string {
       const pickupCenter = this.pickupCenters.find(p => p.centerid.trim() == code.trim() )
       let name : string = '';
        if (pickupCenter){
            name = pickupCenter.centername;
        }
        return name;
    }

 
    // getUnitText(langCode: string, code : string) : Observable<string> {
    //      return this.getUnits(langCode).pipe(
    //         map (result => {
    //             let text : string = '';
    //             const unit  = result.find(unit => unit.codi == code )
    //             if (unit){
    //                 text = unit.text.toLowerCase();
    //             }
    //             return text;
    //         }
    //     ));
    //  }
    
     getUnitText(langCode: string, code : string) : string {
       let text : string = '';
       if (this.units.get(langCode)){
        const unit = this.units.get(langCode).find(unit => unit.codi == code );
        if (unit){
            text = unit.text.toLowerCase();
        }
       }
       return text;

    }

}
